import { useLiveSync } from "../../../../hooks/useLiveSync";
import { requestDineInRefresh } from "../../../../services/firebase/dineInPushRouter";

/**
 * Diner-side resiliency net for the DINE_IN_* push wiring in
 * dineInPushRouter.ts — see useLiveSync for why focus/visibility matters at
 * all. This is the thin, session-shaped wrapper around it.
 *
 * Native doesn't have the gap useLiveSync closes (the bridge calls
 * handleIncomingPush regardless of foreground state), so this is mainly
 * insurance for the plain-browser case, and a harmless extra check there too.
 *
 * Calls the same requestDineInRefresh the push router uses, so a push landing
 * at the exact moment the tab regains focus collapses into one request instead
 * of two.
 */
export function useDineInLiveSync(sessionId: string | undefined): void {
  useLiveSync(!!sessionId, () => {
    if (sessionId) void requestDineInRefresh(sessionId);
  });
}
